<template>
  <v-list-group :value="false" active-class="left-amber-border black--text">
    <template v-slot:activator>
      <v-list-item-icon class="pl-2">
        <v-icon>mdi-currency-usd</v-icon>
      </v-list-item-icon>
      <v-list-item-title class="text-uppercase">Khoản Thu</v-list-item-title>
    </template>
    <v-list class="left-amber-border py-0">
      <v-list-item link to="/sales">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title class="ml-3">Thu Phí</v-list-item-title>
      </v-list-item>
      <v-list-item link to="/liability">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title class="ml-3">Thu Nợ</v-list-item-title>
      </v-list-item>
      <v-list-item link to="/leads">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title class="ml-3">Đơn Hàng</v-list-item-title>
      </v-list-item>
      <v-list-item link to="/bill">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title class="ml-3">Hóa Đơn</v-list-item-title>
      </v-list-item>
      <v-list-item link to="/products">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title class="ml-3">Khoản Thu</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-list-group>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters('app', ['department', 'policies']),
    ...mapGetters('auth', ['user', 'role'])
  }
}
</script>

<style>
.left-amber-border {
  border-left: 4px solid #ffb300 !important;
}
</style>
